// src/common/components/kitList/KitList.tsx

import React from "react";
import { Link } from "react-router-dom";
import { SaleItemInterface } from "../../types/types";
import { KitListItem } from "./KitListItem";
import styles from "./KitList.module.scss";
import { ROUTES } from "../../utils/constants";

type Props = {
  items: Array<{
    childItemId: number;
    quantity: number;
    item: SaleItemInterface;
  }>;
  getCategoryName?: (id: number) => string | undefined;
};

export const KitList = ({ items, getCategoryName }: Props) => {
  if (!items?.length) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Состав комплекта</h3>
      <div className={styles.list}>
        {items.map((kitItem) => {
          const product = kitItem.item;
          if (!product) return null;

          return (
            <Link
              key={kitItem.childItemId}
              to={`${ROUTES.ITEM}/${product.id}`}
              className={styles.link}
            >
              <KitListItem
                item={product}
                quantity={kitItem.quantity}
                getCategoryName={getCategoryName}
              />
            </Link>
          );
        })}
      </div>
    </div>
  );
};
